import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SettingsService } from '@delon/theme';
import {StartupService} from "@core/startup/startup.service";
import { JyUserService } from "../../jy-authorization/user/jy-user.service";

@Component({
  selector: 'passport-lock',
  templateUrl: './lock.component.html',
})
export class UserLockComponent {
  f: FormGroup;

  constructor(
    public settings: SettingsService,
    fb: FormBuilder,
    private router: Router,
    private startupService:StartupService,
    private jyUserService:JyUserService
  ) {
    localStorage.setItem('lockBol','1');
    this.f = fb.group({
      password: [null, Validators.required],
    });
  }
  public passwordError:boolean = false;
  cancelError(){
    this.passwordError = false;
  }
  public loading:boolean = false;
  submit() {
    // tslint:disable-next-line:forin
    for (const i in this.f.controls) {
      this.f.controls[i].markAsDirty();
      this.f.controls[i].updateValueAndValidity();
    }
    if (this.f.valid) {
      this.loading = true;
      this.jyUserService.validate(this.f.value).subscribe((data)=>{
        if(data.status == 'success'){
          localStorage.removeItem('lockBol');
          if(sessionStorage.getItem('lockBeforeUrl')){
            this.router.navigateByUrl(sessionStorage.getItem('lockBeforeUrl'))
          }else{
            this.router.navigateByUrl('/');
          }
          sessionStorage.removeItem('lockBeforeUrl');
        }else{
          this.passwordError = true;
        }
        this.loading = false;
      },() => this.loading = false);
    }
  }
  ngOnInit(){
    this.jyUserService.validate(this.f.value).subscribe();
  }

  goLogin(){
    this.router.navigateByUrl('/passport/login');
  }
}
